import { useEffect } from "react";

// LIBRARIES
import { Routes, Route, useLocation } from "react-router-dom";

// COMPONENTS
import Authenticate from "views/Authenticate/Authenticate";
import AccountDeletion from "views/AccountDeletion/AccountDeletion";
import Dashboard from "views/Dashboard/Dashboard";
import Events from "views/Events/Events";
import Discounts from "views/Discounts/Discounts";
import Reports from "views/Reports/Reports";
import Layout from "components/Layout/Layout";
import LockerDetails from "views/LockerDetails/LockerDetails";
import PreviousDiscounts from "views/PreviousDiscounts/PreviousDiscounts";
import DiscountDetails from "views/DiscountDetails/DiscountDetails";
import PreviousEvents from "views/PreviousEvents/PreviousEvents";
import EventEdit from "views/EventEdit/EventEdit";
import EventDetails from "views/EventDetails/EventDetails";
import Support from "views/Support/Support";
import CreateContainer from "views/CreateContainer/CreateContainer";
import EditLocker from "views/EditLocker/EditLocker";
import LockerList from "views/LockerList/LockerList";
import Audit from "views/Audit/Audit";
import PushNotifications from "views/PushNotifications/PushNotifications";
import ProtectedRoutes from "./ProtectedRoutes";
import Invoices from "views/Invoices/Invoices";

const AppRoutes = () => {
  // CONSTANTS USING HOOKS
  const { pathname } = useLocation();

  // USE EFFECT FUNCTIONS
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Authenticate />} />
      <Route path="/delete-account" element={<AccountDeletion />} />
      <Route element={<ProtectedRoutes />}>
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/reports"
          element={
            <Layout>
              <Reports />
            </Layout>
          }
        />
        <Route
          path="/invoices"
          element={
            <Layout>
              <Invoices />
            </Layout>
          }
        />
        <Route
          path="/lockerList"
          element={
            <Layout>
              <LockerList />
            </Layout>
          }
        />
        <Route
          path="/events"
          element={
            <Layout>
              <Events />
            </Layout>
          }
        />
        <Route
          path="/discounts"
          element={
            <Layout>
              <Discounts />
            </Layout>
          }
        />
        <Route
          path={"lockerList/lockerDetails/:lockerId"}
          element={
            <Layout>
              <LockerDetails />
            </Layout>
          }
        />
        <Route
          path={"/lockerDetails/:lockerId"}
          element={
            <Layout>
              <LockerDetails />
            </Layout>
          }
        />
        <Route
          path="/discounts-history"
          element={
            <Layout>
              <PreviousDiscounts />
            </Layout>
          }
        />
        <Route
          path="/discount/:discountId"
          element={
            <Layout>
              <DiscountDetails />
            </Layout>
          }
        />
        <Route
          path="/events-history"
          element={
            <Layout>
              <PreviousEvents />
            </Layout>
          }
        />
        <Route
          path="/event/:eventId"
          element={
            <Layout>
              <EventDetails />
            </Layout>
          }
        />
        <Route
          path="/event-edit/:eventId"
          element={
            <Layout>
              <EventEdit />
            </Layout>
          }
        />
        <Route
          path="/support"
          element={
            <Layout>
              <Support />
            </Layout>
          }
        />
        <Route
          path="/create-locker/"
          element={
            <Layout>
              <CreateContainer />
            </Layout>
          }
        />
        <Route
          path="/edit-locker"
          element={
            <Layout>
              <EditLocker />
            </Layout>
          }
        />
        <Route
          path="/audit"
          element={
            <Layout>
              <Audit />
            </Layout>
          }
        />
        <Route
          path="/push-notifications"
          element={
            <Layout>
              <PushNotifications />
            </Layout>
          }
        />
        <Route
          path="/discounts"
          element={
            <Layout>
              <Discounts />
            </Layout>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
